//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  OnDestroy,
  OnInit,
  Signal,
  signal,
  TemplateRef,
} from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

//local imports
import { 
  Messenger,
  CloseDialogMessage,
  fadeSlideIn
} from "@app/shared";

import {
  CatalogDataChangedMessage,
  CatalogStateService,
} from "@app/catalog";

@Component({
  selector: 'list-main',
  standalone: false,
  templateUrl: './list-main.component.html',
  styleUrl: './list-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeSlideIn]
})
export class ListMainComponent implements OnInit, OnDestroy  {

  
  public activeFormTemplate = signal<TemplateRef<any> | null>(null);
  public activeAssignmentTemplate = signal<TemplateRef<any> | null>(null);

  public showAddPopup = signal(false);
  public isLoading = computed(() => this.catalogStateService.isLoading());
  
  public catalogDataChanged: Signal<CatalogDataChangedMessage>;
  

  public isAssignMode = computed(() => this.activeAssignmentTemplate() !== null);

  public canEditRoom = computed(() => {
    const rooms = this.rooms();
    return rooms.length > 0 ? rooms[0].canEdit() : false;
  });

  public canEditDepartment = computed(() => {
    const departments = this.departments();
    return departments.length > 0 ? departments[0].canEdit() : false;
  });

  public canEditCategory = computed(() => {
    const categories = this.categories();
    return categories.length > 0 ? categories[0].canEdit() : false;
  });


  public canEditProject = computed(() => {
    const projects = this.projects();
    return projects.length > 0 ? projects[0].canEdit() : false;
  });

  public canEditProgram = computed(() => {
    const programs = this.programs();
    return programs.length > 0 ? programs[0].canEdit() : false;
  })

  public canEditRoomContent = computed(() => {
    const roomContents = this.roomContents();
    return roomContents.length > 0 ? roomContents[0].canEdit() : false;
  });


  public dataLoaded = computed(() => {
    let msg = this.catalogDataChanged();
    return !!msg;
  });

  public companyId = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.companyId;
    return value;
  })


  public roomGroups = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.roomGroups();
    return value;
  });
  
  public rooms = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.rooms();
    return value;
  });

  public departmentGroups = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.departmentGroups();
    return value;
  });



  public departments = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.departments();
    return value;
  });



  public projects = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.projects();
    return value;
  });


  public programs = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.programs();
    return value;
  });


  public categories = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.categories();
    return value;
  });


  public roomContents = computed(() => {
    let msg = this.catalogDataChanged();
    if (!msg) return null;

    let value = msg.catalogManagementData.roomContents();
    return value;
  });
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messenger: Messenger,
    private catalogStateService: CatalogStateService
  ) {
  
    this.setupSubscriptions();

    this.activeFormTemplate = signal(undefined);
    this.catalogDataChanged = this.messenger.getSignal(CatalogDataChangedMessage);
  }


  ngOnInit(): void {
    this.catalogStateService.initialize(this.route);
    this.catalogStateService.syncRouteStateWithBreadCrumbs(this.route);
  }



  private setupSubscriptions() {
    this.messenger.subscribe(this, CloseDialogMessage, () => {
        this.closeForm();
      });
  }


  public openAddForm(template: TemplateRef<any>): void {
    this.activeFormTemplate.set(template);
  }

  public isFormOpen(): boolean {
    return !!this.activeFormTemplate();
  }


  public loadAssignmentTemplate(template: TemplateRef<any>) {
    this.activeAssignmentTemplate.set(template);
  }


  public applyAssignment() {

  }

  public cancelAssignment() {
    this.activeAssignmentTemplate.set(null);
  }

  private closeForm(): void {
    this.activeFormTemplate.set(null);
  }

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
